<template>
  <div>
    <Navbar
      v-if="!isDesktop"
      @desktopNavigate="navigateBackToMode"
      :current_mode="'inside'"
    />

    <MergeModal
      :orders="orders"
      @merge="onMerge"
      @cancel="backToOrders"
      v-if="orders"
    />
  </div>
</template>

<script>
import MergeModal from "@/components/modals/MergeModal.vue";
import Navbar from "@/components/Navbar.vue";

import QueueAPI from "@/api/queue";

export default {
  components: {
    MergeModal,
    Navbar,
  },
  methods: {
    backToOrders() {
      this.$router.push("/orders");
    },
    navigateBackToMode(mode) {
      this.$router.push({
        name: "orders",
        query: {
          m: mode,
        },
      });
    },
    onMerge(primary, secondary) {
      this.$store
        .dispatch("queue/mergeOrders", {
          primary,
          secondary,
        })
        .then((ok) => {
          this.backToOrders();
        });
    },
  },
  mounted() {
    this.$store.dispatch("init", {
      force: false,
    });
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    orders() {
      return this.$store.getters["queue/getOrdersForMerge"](
        this.$route.params.order_id
      );
    },
  },
};
</script>

<style></style>
